import React, { useRef,useContext } from 'react'
import {DataContext } from "../index"
export default function Calculator() {

    const dataContext = useContext(DataContext)
    const getHistoyRef = useRef()
    const [showCal, setShowCal] = dataContext.showCalc;
    const getOutPutRef = useRef()
    const backdropRef = useRef()

    function gethistory() {
        return getHistoyRef.current.innerText;
    }
    function printhistory(num) {
        getHistoyRef.current.innerText = num;
    }
    function getoutput() {
        return getOutPutRef.current.innerText;
    }
    function printoutput(num) {
        if (num === "") {
            getOutPutRef.current.innerText = num;
        } else {
            getOutPutRef.current.innerText = getformattednumber(num);
        }
    }
    function getformattednumber(num) {
        if (num === "-") {
            return "";
        }
        let n = Number(num);
        let value = n.toLocaleString("en");
        return value;

    }
    function reversenumberformat(num) {
        return Number(num.replace(/,/g, ''));
    }

    // let operator = document.getElementsByClassName("ope/rator");
    function handleClickOp(e) {
        console.log(e);
        if (e.nativeEvent.target.id === "clear") {
            printhistory("");
            printoutput("");
        }
        else if (e.nativeEvent.target.id === "backspace") {
            let output = reversenumberformat(getoutput()).toString();
            if (output) {
                output = output.substr(0, output.length - 1);
                printoutput(output);
            }
        } else {

            let output = getoutput();
            let history = gethistory();
            if (output === "" && history !== "") {
                if (isNaN(history[history.length - 1])) {
                    history = history.substr(0, history.length - 1);
                }
            }
            if (output !== "" || history !== "") {
                output = output === "" ?
                    output : reversenumberformat(output);
                history = history + output;
                if (e.nativeEvent.target.id === "=") {
                    let result = eval(history);
                    printoutput(result);
                    printhistory("");
                }
                else {
                    history = history + e.nativeEvent.target.id;
                    printhistory(history);
                    printoutput("");
                }
            }

        }

    }
    return (

        <>
            <div className="backdrop-container" onClick={()=>{
                setShowCal(false)
            }}></div>
            <div id="container">
                <div id="calculator">
                    <div id="result">
                        <div id="history">
                            <p ref={getHistoyRef}></p>
                        </div>

                        <div id="output">
                            <p ref={getOutPutRef}></p>

                        </div>

                    </div>

                    <div id="keyboard">

                        <button className="operator" onClick={(e)=>{handleClickOp(e)}} id="clear">C</button>
                        <button className="operator" onClick={(e)=>{handleClickOp(e)}} id="backspace">CE</button>
                        <button className="operator" onClick={(e)=>{handleClickOp(e)}} id="%">%</button>
                        <button className="operator" onClick={(e)=>{handleClickOp(e)}} id="/">&#247;</button>
                        <button className="number" onClick={function (e) {
                            let output = reversenumberformat(getoutput());
                            if (output !== "NaN") {
                                output = output + e.nativeEvent.target.id;
                                printoutput(output);
                            }
                        }} id="7">7</button>
                        <button className="number" onClick={function (e) {
                            let output = reversenumberformat(getoutput());
                            if (output !== "NaN") {
                                output = output + e.nativeEvent.target.id;
                                printoutput(output);
                            }
                        }} id="8">8</button>
                        <button className="number" onClick={function (e) {

                            let output = reversenumberformat(getoutput());
                            if (output !== "NaN") {
                                output = output + e.nativeEvent.target.id;
                                printoutput(output);
                            }
                        }} id="9">9</button>
                        <button className="operator" onClick={(e)=>{handleClickOp(e)}} id="*">&times;</button>
                        <button className="number" onClick={function (e) {
                            let output = reversenumberformat(getoutput());
                            if (output !== "NaN") {
                                output = output + e.nativeEvent.target.id;
                                printoutput(output);
                            }
                        }} id="4">4</button>
                        <button className="number" onClick={function (e) {
                            let output = reversenumberformat(getoutput());
                            if (output !== "NaN") {
                                output = output + e.nativeEvent.target.id;
                                printoutput(output);
                            }
                        }} id="5">5</button>
                        <button className="number" onClick={function (e) {
                            let output = reversenumberformat(getoutput());
                            if (output !== "NaN") {
                                output = output + e.nativeEvent.target.id;
                                printoutput(output);
                            }
                        }} id="6">6</button>
                        <button className="operator" onClick={(e)=>{handleClickOp(e)}} id="-">-</button>
                        <button className="number" onClick={function (e) {
                            let output = reversenumberformat(getoutput());
                            if (output !== "NaN") {
                                output = output + e.nativeEvent.target.id;
                                printoutput(output);
                            }
                        }} id="1">1</button>
                        <button className="number" onClick={function (e) {
                            let output = reversenumberformat(getoutput());
                            if (output !== "NaN") {
                                output = output + e.nativeEvent.target.id;
                                printoutput(output);
                            }
                        }} id="2">2</button>
                        <button className="number" onClick={function (e) {
                            let output = reversenumberformat(getoutput());
                            if (output !== "NaN") {
                                output = output + e.nativeEvent.target.id;
                                printoutput(output);
                            }
                        }} id="3">3</button>
                        <button className="operator" onClick={(e)=>{handleClickOp(e)}} id="+">+</button>
                        <button className="empty" id="empty"></button>
                        <button className="number" onClick={function (e) {
                            let output = reversenumberformat(getoutput());
                            if (output !== "NaN") {
                                output = output + e.nativeEvent.target.id;
                                printoutput(output);
                            }
                        }} id="0">0</button>
                        <button className="empty" id="empty"></button>
                        <button className="operator" onClick={(e)=>{handleClickOp(e)}} id="=">=</button>

                    </div>

                </div>
            </div>
        </>
    )
}
